<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<CarryOverNewDialog
					:inventory_type="inventory_type"
					:select_items="select_items"
					@add-item="addNewItem($event)"
					text
				/>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<CarryOverNewDialog
						:inventory_type="inventory_type"
						:select_items="select_items"
						@add-item="addNewItem($event)"
					/>
				</v-row>
			</template>
			<v-row no-gutters justify="space-between" align="center">
				<h5 class="text-h6 font-weight-bold">{{ formatMonth() }}</h5>
				<v-spacer />
				<v-row no-gutters justify="end">
					<v-btn
						color="secondary"
						:loading="temporaryBtnLoading"
						@click="
							existing_inventory
								? updateInventory('unsettled', 'temporary')
								: createInventory('unsettled', 'temporary')
						"
					>
						<v-icon class="mr-1"> mdi-content-save-outline </v-icon>
						仮保存</v-btn
					>
					<v-btn
						class="ml-2"
						color="secondary"
						:loading="completeBtnLoading"
						@click="
							existing_inventory
								? updateInventory('pending', 'complete')
								: createInventory('pending', 'complete')
						"
						:disabled="isPending"
					>
						<v-icon class="mr-1"> mdi-check-circle-outline </v-icon>
						完了
					</v-btn>
				</v-row>
			</v-row>

			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="items"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					item-key="target_id"
				>
					<template v-slot:item="{ item }">
						<CarryOverRecord
							:item="item"
							:result="resultByItem(item)"
							:quantity_type="quantity_type"
							:inventory_type="inventory_type"
							@set-result="setResult($event)"
						/>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CarryOverNewDialog from "./components/CarryOverNewDialog.vue"
import CarryOverRecord from "./components/CarryOverRecord.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		CarryOverNewDialog,
		CarryOverRecord,
	},
	data() {
		return {
			title: "棚卸し一覧表",
			month: this.$route.query.month,
			inventory_type: this.$route.params.id,
			items: [],
			existing_inventory: {},
			quantity_type: null,
			select_items: {},
			results: [],
			headers: [
				{
					text: "名称",
					value: "name",
					width: "200px",
				},
				{
					text: "予定個数",
					value: "expected_quantity",
					width: "80px",
				},
				{
					text: "結果",
					value: "result",
					width: "200px",
				},
				{
					text: "確認者",
					value: "user",
					width: "150px",
				},
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			common,
			moment,
			unsettledMessage: "現状のチェック状態を保存しました。棚卸はまだ完了しておりません。",
			completedMessage: "棚卸しのチェックが完了しました。",
			temporaryBtnLoading: false,
			completeBtnLoading: false,
		}
	},

	mounted() {
		this.fetchItems()
	},
	methods: {
		newUuid() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
			)
		},
		fetchItems(page) {
			const params = { month: this.month, inventory_type: this.inventory_type, page }
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/new`
			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					this.quantity_type = res.data.quantity_type
					this.existing_inventory = res.data.inventory
					this.carry_overs = res.data.carry_overs
					if (res.data.carry_overs) this.setFetchResult(res.data.carry_overs, false)
					this.select_items = res.data.select_items
					this.pagination = res.data.pagination
					this.setItems(res.data.items)
					if (this.results.length) {
						this.results.forEach((result) => {
							// 棚卸し項目追加分
							if (result.pagination_current == this.pagination.current) {
								this.items.push({
									target_id: result.target_id,
									name: result.item.wildcard
										? result.item.name + `(${result.item.ordered_product})`
										: this.setName(result.item),
									expected_quantity: 0,
								})
							}
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createInventory(situation, btn_type) {
			if (btn_type == "temporary") this.temporaryBtnLoading = true
			if (btn_type == "complete") this.completeBtnLoading = true
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories`
			this.results.forEach((result) => {
				delete result.item
				delete result.pagination_current
			})

			let params = {
				inventories: {
					situation: situation,
					inventory_type: this.inventory_type,
				},
				results: this.results,
				month: this.month,
			}

			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.existing_inventory = res.data.inventory
					this.setFetchResult(res.data.inventory.carry_overs, true)
					if (res.data.inventory.situation == "unsettled") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: this.unsettledMessage,
						})
					}
					if (res.data.inventory.situation == "pending") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: this.completedMessage,
						})
						this.$router.push({
							name: "inventory_index",
						})
					}

					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => {
					this.completeBtnLoading = false
					this.temporaryBtnLoading = false
				})
		},
		updateInventory(situation, btn_type) {
			if (btn_type == "temporary") this.temporaryBtnLoading = true
			if (btn_type == "complete") this.completeBtnLoading = true

			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/${this.existing_inventory.id}`
			this.results.forEach((result) => {
				delete result.item
				delete result.pagination_current
			})

			let params = {
				inventories: {
					situation: situation,
				},
				results: this.results,
				inventory_type: this.inventory_type,
				month: this.month,
			}

			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.existing_inventory = res.data.inventory
					this.setFetchResult(res.data.inventory.carry_overs, true)
					if (res.data.inventory.situation == "unsettled") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: this.unsettledMessage,
						})
					}
					if (res.data.inventory.situation == "pending") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: this.completedMessage,
						})
						this.$router.push({
							name: "inventory_index",
						})
					}
					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => {
					this.completeBtnLoading = false
					this.temporaryBtnLoading = false
				})
		},
		setFetchResult(carry_overs, is_set) {
			carry_overs.forEach((carry_over) => {
				if (is_set && carry_over.target_type == "OrderComponent") {
					let item = this.items.find(
						(i) =>
							i.unit_price == carry_over.target.unit_price &&
							i.quantity == carry_over.target.quantity &&
							i.target_id == carry_over.target.target_id
					)
					if (item) item.target_id = carry_over.target_id
				}
				if (this.results.some((result) => result.id === carry_over.id)) return
				this.results.push({
					id: carry_over.id,
					target_id: carry_over.target_id,
					target_type: carry_over.target_type,
					quantity: carry_over.quantity,
					user: {
						id: carry_over.user_id,
						full_name: carry_over.user.full_name,
					},
				})
			})
		},
		addNewItem(selectedItems) {
			// itemsに追加
			selectedItems.forEach((selectedItem) => {
				const uuid = this.newUuid()
				this.items.push({
					name: selectedItem.item.wildcard
						? selectedItem.item.name + `(${selectedItem.item.ordered_product})`
						: this.setName(selectedItem.item),
					target_id: selectedItem.item.id,
					target_type: this.setTargetType(selectedItem.item),
					expected_quantity: 0,
					product_number: selectedItem.item.ordered_product,
					unit_price: selectedItem.item.unit_price,
					quantity: this.setQuantity(selectedItem.item),
					uuid: uuid,
				})

				this.results.push({
					name: selectedItem.item.wildcard
						? selectedItem.item.name + `(${selectedItem.item.ordered_product})`
						: this.setName(selectedItem.item),
					pagination_current: this.pagination.current,
					product_number: selectedItem.item.ordered_product,
					unit_price: selectedItem.item.unit_price,
					quantity: this.setQuantity(selectedItem.item),
					wildcard: selectedItem.item.wildcard,
					item: selectedItem.item,
					isAdded: true,
					target_type: this.setTargetType(selectedItem.item),
					target_id: selectedItem.item.id,
					user: {
						id: this.$store.getters["auth/authData"].id,
						full_name: this.$store.getters["auth/authData"].full_name,
					},
					uuid: uuid,
				})
			})
		},
		setItems(items) {
			// order_componentsがある場合は複数のitemがある
			this.items = items.flatMap((i) => {
				if (i.wildcard) {
					return i.order_components.map((order_component) => {
						return {
							target_id: order_component.id,
							target_type: "OrderComponent",
							name: i.wildcard ? this.setOrderComponentName(i, order_component) : this.setName(i),
							expected_quantity: i.wildcard
								? this.setQuantity(i, order_component)
								: this.setQuantity(i),
						}
					})
				} else {
					return {
						target_id: i.id,
						target_type: this.setTargetType(i),
						name: this.setName(i),
						expected_quantity: this.setQuantity(i),
					}
				}
			})
		},
		setName(i) {
			if (this.inventory_type == "product_order_individual_info") {
				let sub_name
				if (i.ordered_product.sub_name == null) {
					sub_name = ""
				} else {
					sub_name = i.ordered_product.sub_name
				}
				return i.ordered_product.product.name + " " + sub_name + i.ordered_product.product_number
			} else if (this.inventory_type == "wip_order_individual_info") {
				let sub_name
				if (i.ordered_product.sub_name == null) {
					sub_name = ""
				} else {
					sub_name = i.ordered_product.sub_name
				}
				return i.ordered_product.product.name + " " + sub_name + i.ordered_product.product_number
			} else if (this.inventory_type == "component") {
				return i.name
			} else if (this.inventory_type == "rubber") {
				return i.name
			} else if (this.inventory_type == "material") {
				return i.name
			} else if (this.inventory_type == "paint") {
				return i.name
			}
		},
		setOrderComponentName(component, order_component) {
			if (order_component.ordered_product) {
				return component.name + `(製造番号 : ${order_component.ordered_product.product_number})`
			}
		},
		setTargetType(item) {
			if (this.inventory_type == "product_order_individual_info") {
				return "OrderIndividualInfo"
			} else if (this.inventory_type == "wip_order_individual_info") {
				return "OrderIndividualInfo"
			} else if (item && item.wildcard == true) {
				return "OrderComponent"
			} else if (item && item.wildcard == false) {
				return "Component"
			} else if (this.inventory_type == "rubber") {
				return "Rubber"
			} else if (this.inventory_type == "material") {
				return "Material"
			} else if (this.inventory_type == "paint") {
				return "Paint"
			}
		},
		setQuantity(i, order_component) {
			// TODO ReceivingShippingを使って予定個数を計算する
			if (this.inventory_type == "product_order_individual_info") {
				return i.quantity
			} else if (this.inventory_type == "wip_order_individual_info") {
				return i.quantity
			} else if (order_component) {
				return order_component.stock
			} else if (this.inventory_type == "component") {
				return i.stock
			} else if (this.inventory_type == "rubber") {
				return i.stock
			} else if (this.inventory_type == "material") {
				return i.stock
			} else if (this.inventory_type == "paint") {
				return i.stock
			}
		},
		setResult(item) {
			if (!this.results.length) window.addEventListener("beforeunload", this.confirmSave)
			let result = this.results.find((r) => r.target_id == item.target_id)
			if (result) {
				let index = this.results.indexOf(result)
				result.quantity = item.quantity
				result.target_type = item.target_type
				result.user = {
					id: this.$store.getters["auth/authData"].id,
					full_name: this.$store.getters["auth/authData"].full_name,
				}
				this.results[index] = result
			} else {
				this.results.push({
					id: item.id,
					target_id: item.target_id,
					target_type: item.target_type,
					quantity: item.quantity,
					user: {
						id: this.$store.getters["auth/authData"].id,
						full_name: this.$store.getters["auth/authData"].full_name,
					},
				})
			}
		},
		resultByItem(item) {
			let result = this.results.find((r) => {
				if (r.uuid) {
					return r.uuid == item.uuid
				} else {
					return r.target_id == item.target_id && r.target_type == item.target_type
				}
			})
			return result
		},
		getPage(page) {
			this.fetchItems(page)
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		confirmSave(event) {
			event.returnValue = "変更したデータは保存されませんが、よろしいですか？"
		},
		formatMonth() {
			return moment(this.month).format("YYYY年MM月")
		},
	},
	computed: {
		isPending() {
			if (this.existing_inventory) {
				this.existing_inventory.situation == "pending" ||
					this.existing_inventory.situation == "completed"
			}
		},
	},
	destroyed() {
		window.removeEventListener("beforeunload", this.confirmSave)
	},
	beforeRouteLeave(to, from, next) {
		if (!this.results.length || this.existing_inventory.situation == "pending") {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
			return
		}
		const answer = window.confirm("変更したデータは保存されませんが、よろしいですか？")
		if (answer) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
		} else {
			next(false)
		}
	},
}
</script>

<style lang="scss">
@import "../../stylesheet/global.scss";
</style>
